// app/studente/classi.js

(function () {
	'use strict';
	var controllerId = 'attach';
	angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', attach]);

	function attach(common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');

		var vm = this;
		vm.title = 'Allegati';
		vm.view = 'list';       //Opzione list or detail
		vm.setView = setView;
		vm.sectionMenu = sectionMenu.setSection(vm.title);

		vm.objName = "attach"; //Utilizzato per pannello authorization
		vm.authorization = {};
		vm.showObjPanel = false;
		vm.record = {};
		vm.records = [];
		vm.countRecords = 0;
		vm.index = 0;
		vm.custom = false;

		vm.addDisabled = false;
		vm.exportDisabled = false;
		vm.pageSize = 30;
		vm.page = 1;
		vm.loading = false;

		//Elenco per Ordinamento
		vm.list = {};
		vm.list.ordine = ['Riferimento', 'Tipo Documento'];
		vm.ordine = vm.list.ordine[0];
		vm.selectOrdine = function (item) {
			vm.ordine = item;
		};

		vm.getRecord = getRecord;



		//Filtro
		vm.filter = {};
		vm.fTAttachId = 0;
		vm.fTSourceId = 0;
		vm.filter.bAttivo = 1;
		vm.filter.codiceProgetto = 0;
		vm.filter.tAttachId = vm.fTAttachId;
		vm.filter.tSourceId = vm.fTSourceId;
		


		//Elenchi per filtri e finestra modale di Create
		vm.tAttach = [];
		vm.tSource = [];

		//Metodi su interfaccia
		vm.cerca = cerca;
		vm.activated = false;
		vm.loadMore = getAllByFilter;
		vm.loadAll = getAll;

		vm.goNext = goNext;
		vm.goPrev = goPrev;


		vm.get = getRecord;
		vm.add = addModal;
		vm.update = updateItem;
		vm.delete = deleteItem;
		vm.getTAttach = getTAttach;

		// ---- ACTIVATE -------
		activate();

		function activate() {
			var promises = [getTSource(), getTAttach(), getAuthorization()];
			common.activateController(promises, controllerId)
							.then(function () {

								if ($routeParams.ClasseId != null) {
									setView('detail');
									getRecord($routeParams.ClasseId, 0);
								}

							});
		}


		//****************************************************
		// METODI 
		//****************************************************
		function setView(view) {
			return vm.view = view;
		}

		function cerca() {
		    vm.activated = true;
			vm.records = [];
			vm.countRecords = 0;
			vm.page = 1;
			vm.filter.tSourceId = vm.fTSourceId == null ? 0 : vm.fTSourceId;
			vm.filter.tAttachId = vm.fTAttachId == null ? 0 : vm.fTAttachId;


			vm.loading = false;
			countByFilter();
			return getAllByFilter();
		}

		function countByFilter() {
			return datacontext.attach_countAll('', vm.filter.tSourceId, vm.record.Id, vm.filter.tAttachId)
						.then(function (data) {
							if (data) {
								vm.countRecords = data;
							}
						});
		}

		function getAllByFilter() {
			if (vm.loading === true) return;

			if (vm.countRecords == 0) countByFilter();
			else if (vm.countRecords <= vm.records.length) return;

			vm.loading = true;
			return datacontext.attach_getAll(vm.pageSize, vm.page, '', vm.filter.tSourceId, vm.record.Id, vm.filter.tAttachId, vm.ordine)
					.then(function (data) {
						if (data.constructor === Array) {
							vm.page++;
							data.forEach(function (item) {
								vm.records.push(item);
							});
						}
						vm.loading = false;
					});
		}

		function getAll() {
			if (vm.records.length < vm.countRecords) {
				getAllByFilter().then(function () { getAll(); });
			}
		}

		function getAuthorization() {
            vm.addDisabled = true;
            
			return datacontext.authorization_get(vm.objName)
					.then(function (data) {
						vm.authorization = data;
						vm.addDisabled = !vm.authorization.bInsert;
					});
        }

		function getRecord(id, index) {
			return datacontext.attach_get(id).then(function (data) {
				vm.index = index;
				vm.record = data;

				setView('detail');
			});
		}

		function goNext() {
			if (vm.index + 1 >= vm.countRecords) return;
			if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
				getByFilter();
			}
			if (!vm.records) return;

			vm.index++;
			return getRecord(vm.records[vm.index].Id, vm.index);
		}

		function goPrev() {
			if (vm.index == 0) return;
			if (!vm.records) return;

			vm.index--;

			return getRecord(vm.records[vm.index].Id, vm.index);
		}


		function addRecord(id) {
			return datacontext.attach_get(id).then(function (data) {
				vm.records.push(data);
				vm.countRecords++;
			});
		}

		function updateItem() {
			return datacontext.attach_update(vm.record).then(function (data) {

				if (data == "400") return logError('Errore cancellazione dati [' + data + ']');

				vm.records[vm.index] = data;
				logSuccess('Record Salvato ');
			});
		}

		function deleteItem(item) {
			var msg = ' Allegato: ' + item.Name + ' (' + item.TSource + ' - ' + item.Source + ')';
			bDialog.deleteDialog(msg).then(function () {
				return datacontext.attach_delete(item.Id).then(function (data) {
					if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

					var index = vm.records.indexOf(item)
					vm.records.splice(index, 1);
					vm.countRecords--;
				});
			});
		}		

		//Elenchi Parametri
		function getTSource() {
			return datacontext.tSource_getAllList().then(function (data) {
				return vm.tSource = data;
			});
		}

		function getTAttach() {
			var tSourceId = vm.fTSourceId;
			return datacontext.tAttach_getAllList('', vm.fTSourceId, 0, 0).then(function (data) {
				return vm.tAttach = data;
			});
		}

		//****************************************************
		// OPEN MODAL DIALOG
		//****************************************************
        function addModal(item) {
			var modalInstance = modal.open({
				backdrop: 'static',
				keyboard: false,
				templateUrl: '/app/attach/modal/attachAdd.html?version=30',
				controller: 'attachAdd',
				resolve: {
					tSource: function () {
						return vm.tSource;
					},
					tSourceId: function () {
						return null;
					},
					tSourceCode: function () {
						return null;
					},
					source: function () {
						return null;
					},
					sourceId: function () {
						return null;
					},
					tAttach: function () {
						return vm.tAttach;
					},
					tAttachId: function () {
						return null;
                    },
                    attach: function () {
                        return item;
                    }

				}
			});

			modalInstance.result.then(function (returnItem) {
				if (!returnItem) return logError('errore di creazione! ');

				logSuccess('Dato salvato con successo! ');
				addRecord(returnItem.Id);
			}, function () {
				//log('Modal dismissed at: ' + new Date());
			});
        };

        //******************** Metodi per Attach2
        /*
        function getListAttach(id) {
            if (!id) return;
            return datacontext.attach_getAllCND(0, 0, 'vm.cndProgetto.UID', 'vm.record.UID', 'TSourceCode', 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;

                return datacontext.tAttach_getAll(0, 0, 'TSourceCode', 0, '', 0, '').then(function (data) {

                    vm.tAttach_Needed = data;
                    vm.tAttach_Needed.forEach(function (item_TA) {

                        var myrec = _.find(vm.list.attach, { 'TAttachId': item_TA.Id });

                        if (typeof (myrec) == 'undefined') {
                            if (typeof (vm.list.attach) == 'undefined') vm.list.attach = [];
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;
                            vm.list.attach.push(att);
                        }

                    });
                });

                return vm.list.attach;
            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {

                return vm.tAttach_Needed = data;
            });
        }


        // ATTACH2
        function addAttach2(tAttachId, item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name }
            var recSource = { Id: vm.record.Id, Name: vm.record.RagioneSociale }

            var modalInstance = modal.open({
                templateUrl: '/app/attach/modal/attachAdd2.html?version=30',
                controller: 'attachAdd2',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return vm.tAttach_Needed;
                    },
                    tAttachId: function () {
                        return tAttachId;
                    },
                    attach: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                if (returnItem == "400") return logError('Errore registrazione dati [' + returnItem + ']');

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);
                //vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };
        */




	}
})();
